var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMatchCount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M24.762 0C25.446 0 26 .554 26 1.238v23.524c0 .684-.554 1.238-1.238 1.238H1.238A1.238 1.238 0 0 1 0 24.762V1.238C0 .554.554 0 1.238 0zM19.8 14H6.2a.2.2 0 0 0-.2.2v2.6c0 .11.09.2.2.2h13.6a.2.2 0 0 0 .2-.2v-2.6a.2.2 0 0 0-.2-.2zm0-5H6.2a.2.2 0 0 0-.2.2v2.6c0 .11.09.2.2.2h13.6a.2.2 0 0 0 .2-.2V9.2a.2.2 0 0 0-.2-.2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMatchCount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/match-count.1b5fdccae94e7322e4ef9827902018c6.svg";